import React from "react";

// MindWorks brand mark — uses the actual logo asset extracted from the
// official artwork (white on transparent). `size` controls the rendered height
// in pixels; the image keeps its natural circular aspect.
const Logo = ({ size = 40 }) => {
    return (
        <img
            src="/mindworks-logo.png"
            alt="MindWorks logo"
            width={size}
            height={size}
            style={{ height: size, width: size, objectFit: "contain" }}
            draggable={false}
            data-testid="mindworks-logo"
        />
    );
};

export default Logo;
